import { useRef, useEffect } from "react";

/**
 * Hook that returns the previous value of a variable.
 * @param value - The current value to track
 * @returns The previous value of the variable
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
